import type { PendingQuoteInfosMap, QuoteInfos } from './pendings.model';

export function getQuoteInfos(state: PendingQuoteInfosMap, tabId: string | undefined): QuoteInfos | undefined {
  return tabId ? state[tabId] : undefined;
}
